import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const API_URL = process.env.REACT_APP_API_URL;


export const fetchProperties = createAsyncThunk(
    "properties/fetchProperties",
    async (params = {}, { rejectWithValue }) => {
      try {
        // Если токен передается через параметры, включаем его в заголовки
        const { token, ...searchParams } = params;
        const queryString = new URLSearchParams(searchParams).toString();
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/api/v1/property/search?${queryString}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                ...(token && { Authorization: `Bearer ${token}` }),
              },
            }
        );
        if (!response.ok) {
          const errorData = await response.json();
          return rejectWithValue(errorData.error || "Произошла ошибка");
        }
        return await response.json();
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
);

const propertiesSlice = createSlice({
  name: "properties",
  initialState: {
    data: [],
    page: 1,
    pageSize: 9,
    total: 0,
    totalPages: 0,
    status: "idle",
    error: null,
  },
  reducers: {
    clearProperties: (state) => {
      state.data = [];
      state.error = null;
      state.status = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
        .addCase(fetchProperties.pending, (state) => {
          state.status = "loading";
          state.error = null;
        })
        .addCase(fetchProperties.fulfilled, (state, action) => {
          state.status = "succeeded";
          // Предполагается, что сервер возвращает объект с ключами: data, page, pageSize, total, totalPages
          state.data = action.payload.data;
          state.page = action.payload.page;
          state.pageSize = action.payload.pageSize;
          state.total = action.payload.total;
          state.totalPages = action.payload.totalPages;
        })
        .addCase(fetchProperties.rejected, (state, action) => {
          state.status = "failed";
          state.error = action.payload;
        });
  },
});

export const { clearProperties } = propertiesSlice.actions;
export default propertiesSlice.reducer;
